import { ChangeDetectionStrategy, Component, computed, input, OnInit, output, Signal } from '@angular/core'
import { CertificateBaseComponent } from '@features/certificate/components/certificate-base/certificate-base.component'
import {
  CertCertificateHolderApiResponse,
  CertificateHolderApiResponse,
  CertificateHolderEmail
} from '@features/certificate-holder/models/certificate-holder.model'
import { ButtonDirective } from 'primeng/button'
import { Tooltip } from 'primeng/tooltip'
import {
  CertificateHolderEntityManagerComponent
} from '@features/certificate/components/certificate-holder-entity-manager/certificate-holder-entity-manager.component'
import {
  AddressDisplayActionsDirective,
  AddressSearchActionsDirective,
  HolderDisplayActionsDirective,
  HolderSearchActionsDirective
} from '@features/certificate/components/certificate-holder-entity-manager/certificate-holder-row-action.directive'
import {
  buildGroupedRows,
  buildSearchResultRows,
  CertificateHolderRow,
  createCertificateHolderSearch
} from '@features/certificate/utils/certificate-holder-search.util'

export type AcrRow = CertificateHolderRow

@Component({
  selector: 'albert-certificate-acr',
  imports: [
    ButtonDirective,
    Tooltip,
    CertificateHolderEntityManagerComponent,
    HolderDisplayActionsDirective,
    AddressDisplayActionsDirective,
    HolderSearchActionsDirective,
    AddressSearchActionsDirective
  ],
  templateUrl: './certificate-acr.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CertificateAcrComponent extends CertificateBaseComponent implements OnInit {
  public readonly additionalCertificateRecipients = input.required<Signal<CertCertificateHolderApiResponse[]>>()
  public readonly addRecipientWithoutEmails = output<CertificateHolderApiResponse>()
  public readonly addSingleRecipientEmail = output<{ holder: CertificateHolderApiResponse; address: CertificateHolderEmail }>()
  public readonly removeRecipient = output<number>()
  public readonly removeRecipientAddress = output<{ holderIndex: number; addressIndex: number }>()
  public readonly groupedRows = computed<AcrRow[]>(() => buildGroupedRows(this.additionalCertificateRecipients()()))
  public readonly groupedRowsByHolder = computed(() => this.groupedRows().filter(row => row.type === this.certificateHolderRowType.HOLDER))
  public readonly searchResultRows = computed<AcrRow[]>(() =>
    buildSearchResultRows(this.searchResults(), this.additionalCertificateRecipients()())
  )
  private readonly search = createCertificateHolderSearch()
  public readonly searchForm = this.search.searchForm
  public readonly searchQuery = this.search.searchQuery
  public readonly searchResults = this.search.searchResults
  public readonly isSearching = this.search.isSearching

  public ngOnInit(): void {
    this.search.init()
  }

  public onAddRecipientWithoutEmails(holder: CertificateHolderApiResponse): void {
    this.addRecipientWithoutEmails.emit(holder)
  }

  public onAddSingleRecipientEmail(holderIndex: number, addressIndex: number): void {
    const holder = this.searchResults()[holderIndex]!
    const address = (holder.recipientAddresses ?? [])[addressIndex]!
    this.addSingleRecipientEmail.emit({ holder, address })
  }

  public onRemoveRecipient(holderIndex: number): void {
    this.removeRecipient.emit(holderIndex)
  }

  public onRemoveRecipientAddress(holderIndex: number, addressIndex: number): void {
    this.removeRecipientAddress.emit({ holderIndex, addressIndex })
  }
}
